import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class TxnTypeFilter extends Component {
    state = {
        txnTypeLists:[],
        txnTypeValue: ''
    };
    componentDidMount(){
        this.getTxnType();
    }
    resetTxnTypeFilter() {
        this.setState({
            txnTypeValue: [],
        })
    }
    getTxnType(){
        axios.get(config.get('API_URL')+'/filters/get-txn-type/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                is_upi_leg1: this.props.is_upi_leg1,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((txn_type, index) => {
                    this.state.txnTypeLists.push({value: txn_type.txn_code, label: txn_type.txn_display_name})
                });
            }
//             this.setState({
//                 isTenderModeLoading: false
//             })
        });

    }

    changeTxnType(optionSelected){
        let value='';
        let txnArray = [];
        if (optionSelected.length < 1) {
            value = null;
            txnArray = ["all"];
        }
        else{
            optionSelected.map((mids, i) => {
                txnArray.push(mids.value)
                // var index = this.state.txnTypeLists.findIndex(obj => obj.value==mids.value);
                // this.state.txnTypeLists.move(index,0).join(',');
            });
        }
        if(txnArray.includes("FAILED")===true && txnArray.includes("UPI Leg1")===true) {
            txnArray = txnArray[0];
            optionSelected = [{value: txnArray[0], label: txnArray[0]}];
        }
        if(txnArray.includes("FAILED")===true) {
            txnArray = ['FAILED'];
            optionSelected = [{value: "FAILED", label: "FAILED"}];
        }
        if(txnArray.includes("UPI Leg1")===true) {
            txnArray = ['UPI Leg1'];
            optionSelected = [{value: "UPI Leg1", label: "UPI Leg1"}];
        }
        this.props.onSelectTxnType(optionSelected,txnArray);
        this.setState({
            txnTypeValue:optionSelected,
        });
    }
    render() {
        return (
            <ReactMultiSelectCheckboxes name="txn_type"
                isMulti
                value={this.state.txnTypeValue}
                 styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeTxnType.bind(this)}
                options={this.state.txnTypeLists}
                placeholderButtonLabel="Select [Txn Type ]"
            />
        );

    }
}
export default TxnTypeFilter;